var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "raft-file-upload-row"
  }, [_c('span', [_vm._v(_vm._s(_vm.attachedFile.name)), _c('b-button', {
    attrs: {
      "disabled": _vm.disableRemoval
    },
    on: {
      "click": function ($event) {
        return _vm.removeFile(_vm.attachedFile);
      }
    }
  }, [_vm._v("\n      Remove")])], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }